import { render } from "./ipdDemandModel.vue?vue&type=template&id=36d959ce"
import script from "./ipdDemandModel.vue?vue&type=script&lang=js"
export * from "./ipdDemandModel.vue?vue&type=script&lang=js"

import "./ipdDemandModel.vue?vue&type=style&index=0&id=36d959ce&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__